const getPrimaryPlacement = val => val?.split('-')?.[0];
function isVerticalPlacement(side) {
  return side ? ['left', 'right'].indexOf(side) !== -1 : false;
}
function getOppositePlacement(side) {
  switch (side) {
    case 'top':
      return 'bottom';
    case 'left':
      return 'right';
    case 'bottom':
      return 'top';
    default:
      return 'left';
  }
}
function getAlignment(placement) {
  const align = placement?.split('-')?.[1];
  switch (align) {
    case 'start':
      return 'left';
    case 'end':
      return 'right';
    default:
      return 'center';
  }
}
function getTransformOrigin(placement, arrowStyles) {
  const basePlacement = getPrimaryPlacement(placement);
  if (arrowStyles === undefined) {
    return isVerticalPlacement(basePlacement) ? `${getOppositePlacement(basePlacement)} ${getAlignment(basePlacement)}` : `${getAlignment(basePlacement)} ${getOppositePlacement(basePlacement)}`;
  }
  // const arrowSizeShift = state.elements.arrow.clientHeight / 2;
  const arrowSizeShift = 30 / 2;
  // can use keyword for dimension without the arrow, to ease computation burden.
  // move origin by half arrow's height to keep it centered.
  return isVerticalPlacement(basePlacement) ? `${getOppositePlacement(basePlacement)} ${parseInt(arrowStyles.top, 10) + arrowSizeShift}px` : `${parseInt(arrowStyles.left, 10) + arrowSizeShift}px ${getOppositePlacement(basePlacement)}`;
}

export { getAlignment, getOppositePlacement, getPrimaryPlacement, getTransformOrigin, isVerticalPlacement };
